import React, {useState,useRef, useEffect} from "react";
import "./copyRightPolicy.css";
const CopyRightPolicy = () =>{
    const [isOpen, setIsOpen] = useState(true); // Set default state to true (popup open)
    const modalRef = useRef(null); // Reference for the modal
    const closeButtonRef = useRef(null); // Reference for the close button

      // Function to close the modal
  const handleClose = () => {
    setIsOpen(false); // Set state to false to close the modal
  };

  // Function to handle clicks outside the modal
  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target) && !closeButtonRef.current.contains(event.target)) {
      handleClose(); // Close the modal if the click is outside
    }
  };

  useEffect(() => {
    // Add the event listener on component mount
    document.addEventListener("mousedown", handleOutsideClick);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);
    return(
        <>
         {isOpen && (
         
        <div className="copyRightPolicy" ref={modalRef}>
            <div className="close-button-crp" ref={closeButtonRef}>
                        <button className="close-popup-btn-crp" onClick={handleClose} >
                        ✖
                        </button>
            </div>
            <div className="heading-copyRightPolicy">
                <h1>COPYRIGHT POLICY</h1>
            </div>
            <div className="copyRightPolicy-content">
            <div className="about-crp">
            <p>At Pixwala, we respect the intellectual property rights of others and expect our users to do the same. This Copyright Policy outlines the ownership and usage of the content provided on our website and how we handle copyright infringement.</p>
            </div>
            <div className="bulletPoints-crp">
                <div className="heading-bulletPoints-crp">
                Ownership of Content
                </div>
                <div className="data-bulletPoints-crp" >
                        <p>All content on Pixwala.com, including but not limited to logos, images, text, videos, portfolio pieces, and other materials, is created and owned by Pixwala. This content is protected by copyright law, and we retain all rights to it. We do not use third-party content unless otherwise stated.</p>
                        {/* <ol className=" custom-list custome-list-1-crp"> */}
                </div>

                <div className="heading-bulletPoints-crp">
                Use of Content
                </div>
                <div className="data-bulletPoints-crp" >
                        <p>The content on our website is for display purposes only. We do not allow users to download or use any of the materials on our website without our express permission. While we share our portfolio with potential clients who have requested it, the shared content will always carry our watermark and logo.</p>
                        {/* <ol className=" custom-list custome-list-2-crp"> */}
                </div>

                <div className="heading-bulletPoints-crp">
                Copyright Infringement          
                    </div>
                    <div className="data-bulletPoints-crp" >
                    <p>If you believe that any content on our website infringes upon your copyright, please contact us with the following information:</p>
                    <ol className="custom-list custome-list-3-crp">
                            <li><span>A description of the copyrighted work that you believe has been infringed.</span></li>
                            <li><span>A link to the specific content you believe is infringing.</span></li>
                            <li><span>Your contact information, including your address, phone number, and email address.</span></li>
                        </ol>
                        <p>Upon receiving a valid takedown request, we will review it and may remove the infringing content. If you engage in unlawful use of our copyrighted material, we reserve the right to pursue legal action.</p>
                    </div>

                    <div className="heading-bulletPoints-crp">
                    Takedown Process
                </div>
                <div className="data-bulletPoints-crp" >
                        <p>If you believe that your content has been used without permission or in violation of your copyright, you may request that the content be removed by sending a takedown notice to us. In the event of repeat infringement, we may permanently suspend the access of the infringing user.</p>
                        {/* <ol className=" custom-list custome-list-4-crp"> */}
                </div>

                <div className="heading-bulletPoints-crp">
                Legal Actions
                </div>
                <div className="data-bulletPoints-crp" >
                        <p>In the event of persistent or serious copyright infringement, we will not hesitate to take legal action to protect our intellectual property rights.</p>
                        {/* <ol className=" custom-list custome-list-5-crp"> */}
                </div>

                <div className="heading-bulletPoints-crp">
                Contact Information           
                    </div>
                    <div className="data-bulletPoints-crp" >
                    <p>For any questions or concerns related to this Copyright Policy or to report an infringement, please contact us at:</p>
                    <ol className="custom-list custome-list-6-crp">
                            <li><span><strong>Email: </strong>contact@pixwala.com</span></li>
                            <li><span><strong>Phone: </strong>+91 86996-21455</span></li>
                            <li><span><strong>WhatsApp: </strong>+91 86996-21455</span></li>
                        </ol>
                    </div>

            </div>

            </div>
           
           
        </div>
        )}
        </>
    );
};
export default CopyRightPolicy;